import React from 'react';
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import PasswordInput from '../../Components/PasswordInput/PasswordInput';
import { useNavigate } from 'react-router-dom';


function Account(props) {
  const userType = 'admin';
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const name = user.name || "";
  const email = user.email || "";
  const businessNames = [...new Set((user.businessUnits ?? []).map((unit) => unit.name))].join(", ");
  const navigate = useNavigate();
  const rol =
  user.isAdmin === 2
      ? "Administrador"
      : [
          ...new Set(
            user.businessUnits.flatMap((unit) =>
              unit.appUserRoles.map((role) => role.name)
            )
          ),
        ].join(", ");

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">

        {/* Tu cuenta */}
        <>
          <div className="row mt-40">
            <div className="col-12 col-md-6 col-lg-3">
              <a href="/">
              <button className="btn -text" onClick={handleGoBack}>
                <i class="fa-solid fa-arrow-left"></i> Regresar
              </button>
              </a>
            </div>
          </div>
          <div className="row centered align-content-center">
            <div className="col-12 col-md-8">
              <div className="card -walnut">
                <div className="row">
                  <div className="col">
                    <p className="h2">
                      Tu cuenta
                    </p>
                  </div>
                </div>
                <div className="row mt-24">
                  <div className="col-12 col-md-6 mt-3 align-content-top">
                    <label htmlFor="userName" className="form-label">Usuario</label>
                    <p className="body-1 -m">{name}</p>
                  </div>
                  <div className="col-12 col-md-6 mt-3 align-content-top">
                    <label htmlFor="userMail" className="form-label">Correo</label>
                    <p className="body-1 -m">{email}</p>
                  </div>
                  <div className="col-12 col-md-6 mt-3 align-content-top">
                    <label htmlFor="userSociety" className="form-label">Sociedad/es</label>
                    <p className="body-1 -m">{businessNames}</p>
                  </div>
                  <div className="col-12 col-md-6 mt-3 align-content-top">
                    <label htmlFor="userRole" className="form-label">Rol</label>
                    <p className="body-1 -m">{rol}</p>
                  </div>
                </div>
                {/* <div className="row mt-40">
                  <div className="col-12 col-md-6 align-content-end">
                    <label htmlFor="password" className="form-label">Contraseña</label>
                    <input type="password" className="form-control -input" id="userName" placeholder="******" disabled />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-md-16 align-content-end">
                    <a href="/">
                      <button className="btn -primary">
                        Cambiar contraseña
                      </button>
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </>
        {/* Tu cuenta */}
      
        {/* Register Users */}
        {/* <div className="row centered align-content-center">
          <div className="col-12 col-md-8 col-lg-5">
            <div className="card -walnut">
              <div className="row">
                <div className="col">
                  <p className="h2">
                    Cambiar contraseña
                  </p>
                  <p className="body-2 mt-8">
                    Hola <span className="body-2 -m">Marco</span>, ingresa tu contraseña actual para autentificar tu cuenta.
                  </p>
                </div>
              </div>
              <div className="row mt-24">
                <div className="row mt-24 justify-content-center">
                  <div className="col-12">
                    <PasswordInput
                      label="Contraseña actual"
                      placeholder="Ingresa tu contraseña."
                      requiredMessage="La contraseña es requerida."
                      invalidMessage="La contraseña que ingresaste es incorrecta. Inténtalo de nuevo o cierra sesión y haz click en “¿Haz olvidado tu contraseña?” para restablecerla."
                    />
                  </div>
                  <div className="col-12">
                    <PasswordInput
                      label="Nueva contraseña"
                      placeholder="Ingresa contraseña nueva."
                      requiredMessage="La contraseña es requerida."
                      invalidMessage=""
                    />
                  </div>
                  <div className="col-12">
                    <PasswordInput
                      label="Confirmar contraseña"
                      placeholder="Ingresa contraseña nueva."
                      requiredMessage="La contraseña es requerida."
                      invalidMessage="Las contraseñas no coinciden."
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-40 justify-content-center">
                <div className="col-12">
                  <a href="/">
                    <button className="btn -text text-c">
                      ¿Haz olvidado tu contraseña?
                    </button>
                  </a>
                </div>
                <div className="col-12 mt-24">
                  <a href="/">
                    <button className="btn -primary">
                      Continuar
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Register Users */}
      </div>
    </div>
  );
}

export default Account;